
































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrSizhenhecan extends Vue {
  @Prop()
  private message: any;
  private current: any = {
    体质得分: {}
  };
  private changeCurrentItem(item) {
    this.$set(this, "current", item);
  }
  private mounted() {
    if (this.message && this.message.length > 0) {
      this.current = this.message[0];
    }
  }
}
